import { Typography } from '@/components/ui/typography';

type TrashSummaryProps = {
  itemCount: number;
};

// AssetsControlBar's `leadingActions` slot for the Trash tab: just the item
// count. The photoset select and Request Support now live on AssetsControlBar
// itself (Unit 4 PR A, spec §1.3) — every trash action is per-item (see the
// spec's Out of scope), so there is no menu slot either.
const TrashSummary = ({ itemCount }: TrashSummaryProps) => (
  <Typography variant="body-semibold" className="text-foreground">
    {itemCount} {itemCount === 1 ? 'Item' : 'Items'}
  </Typography>
);

export default TrashSummary;
